import isoUrl from '../../assets/tivy-iso.svg'
import logoClaroUrl from '../../assets/tivy-logo-claro.svg'
import logoOscuroUrl from '../../assets/tivy-logo-oscuro.svg'

const SOURCES = {
  iso: isoUrl,
  claro: logoClaroUrl,
  oscuro: logoOscuroUrl
} as const

type TivyLogoVariant = keyof typeof SOURCES

interface TivyLogoProps extends Omit<React.ImgHTMLAttributes<HTMLImageElement>, 'src' | 'alt'> {
  variant: TivyLogoVariant
  alt?: string
}

/**
 * Logo de Tivy v2 (ADR 006).
 *
 * - `iso`: isotipo con gradiente verde (la "T" estilizada). Se usa como mark
 *   independiente, en favicon, PWA icons, y en superficies muy chicas.
 * - `claro`: logo completo para fondos oscuros. Es el caso default de Tivy
 *   (consola dark, kiosko, galerías públicas).
 * - `oscuro`: logo completo para fondos claros. Reservado para casos
 *   puntuales (eventos con tema light, exports impresos).
 */
export function TivyLogo({ variant, alt = 'Tivy', ...rest }: TivyLogoProps) {
  return <img src={SOURCES[variant]} alt={alt} draggable={false} {...rest} />
}
